import type { ContentMediumType, UserData } from "../../constants/GlobalTypesAndEnumsAndConstants";
import { addSentryDiagnosticBreadcrumb, trackError } from "../../utils/analytics/track-error";
import {
  ContentIngestionError,
  ContentIngestionErrorCode,
  buildContentIngestionFailureTelemetry,
} from "./content-ingestion-observability";

export function reportContentUrlIngestionFailure({
  error,
  attemptId,
  sourceUrl,
  contentMediumType,
  user,
}: {
  error: ContentIngestionError;
  attemptId: string;
  sourceUrl: string;
  contentMediumType: ContentMediumType | null;
  user: UserData;
}): void {
  const telemetry = buildContentIngestionFailureTelemetry({
    error,
    attemptId,
    sourceUrl,
    contentMediumType,
    isOnline: navigator.onLine,
  });
  const sentryError = error.responseText
    ? new ContentIngestionError({
        message: error.message,
        stage: error.stage,
        code: error.code,
        retryable: error.retryable,
        requestAttempts: error.requestAttempts,
        httpStatus: error.httpStatus,
        cfRayId: error.cfRayId,
      })
    : error;
  const isExpectedSourceRejection =
    !error.retryable &&
    (error.code === ContentIngestionErrorCode.InvalidUrl ||
      error.code === ContentIngestionErrorCode.SourceRejected);
  if (isExpectedSourceRejection) {
    addSentryDiagnosticBreadcrumb({
      category: "content-url-ingestion",
      message: "Content source was rejected before generation",
      data: {
        ...telemetry,
        userId: user?.id || null,
        sentryOrigin: "frontend",
      },
    });
    return;
  }
  trackError(sentryError, {
    scope: "content-url-ingestion",
    userId: user?.id,
    level: "error",
    tags: {
      content_ingestion_stage: error.stage,
      content_ingestion_error_code: error.code,
      content_ingestion_request_attempts: String(error.requestAttempts),
      ingestion_attempt_id: attemptId,
      content_medium_type: contentMediumType || "unknown",
      source_youtube_video_id: String(telemetry.sourceYouTubeVideoId || "not-youtube"),
    },
    extra: {
      ...telemetry,
      sentryOrigin: "frontend",
      documentVisibility: document.visibilityState,
    },
  });
}
